// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Wntfm","img":"styles_img__DWGFg","name":"styles_name__HcfBr"};